import { render, staticRenderFns } from "./TUWEN011.vue?vue&type=template&id=13698b56"
import script from "./TUWEN011.vue?vue&type=script&lang=js"
export * from "./TUWEN011.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports